import { render } from "./Smartphone2.vue?vue&type=template&id=7941a0c0&scoped=true"
const script = {}

import "./Smartphone2.vue?vue&type=style&index=0&id=7941a0c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7941a0c0"

export default script